import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export function MpgCard({
  heading = null,
  className = 'py-1_5 px-1_5',
  badge = null,
  children,
  creativeId = null,
  titleTag: TitleTag = 'h2',
}) {
  return (
    <div
      className={classnames('mpg-card bg-white rounded-12 text-cool-gray-40 mb-1', className)}
      data-tracking-parent={creativeId}
    >
      {!!heading && (
        <div className="d-flex justify-content-between align-items-center mb-1_5">
          <TitleTag className="size-16 fw-bold text-cool-gray-30 mb-0">{heading}</TitleTag>
          {badge}
        </div>
      )}
      {children}
    </div>
  );
}

MpgCard.propTypes = {
  children: PropTypes.node.isRequired,
  heading: PropTypes.string,
  badge: PropTypes.node,
  className: PropTypes.string,
  creativeId: PropTypes.string,
  titleTag: PropTypes.string,
};
